import { Component, OnInit, OnDestroy } from '@angular/core';
import { ToastService, MDBModalRef, MDBModalService } from 'ng-uikit-pro-standard';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { GeneralService } from 'src/app/services/general.service';
import { Subject, Observable, Subscription, timer } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-new-coment-blog-modal',
  templateUrl: './new-coment-blog-modal.component.html',
  styleUrls: ['./new-coment-blog-modal.component.scss']
})
export class NewComentBlogModalComponent implements OnInit, OnDestroy {

  public _formEntity: FormGroup;
  currentDate: any;
  action: Subject<any> = new Subject<any>();
  salesLeadsId: any;
  replyId: any;
  timer$: Observable<number> = timer(0, 1000);
  private subcrition: Subscription;
  constructor(
    private toast: ToastService,
    public modalRef: MDBModalRef,
    public GeneralService: GeneralService,
    private modalService: MDBModalService,
    private translate:TranslateService

  ) { }

  ngOnInit() {
    this.initForm();

    this.subcrition = this.timer$.subscribe(
      secondsElapsed => {
        this.getcurrentDate();
        console.log(secondsElapsed +'-' + this.currentDate);

      }
    );

    let datas;

    datas = this.modalService.config.data;
    this.salesLeadsId = parseInt(datas.id);
    if (datas.replyId) {
      this.replyId = datas.replyId
    } else {
      this.replyId = null;
    }
  }
  ngOnDestroy() {
    this.subcrition.unsubscribe();
  }
  closeModal() {
    this.modalRef.hide();
  }

  initForm(item?: any) {
    this._formEntity = new FormGroup({
      description: new FormControl({ value: '', disabled: false }, []),
    });
  }

  submitForm() {
     let formValue;
    formValue = this._formEntity.value;

    if (this.replyId) {
      formValue = {
        id: 0,
        date: this.currentDate,
        projectid: this.salesLeadsId,
        parentid: this.replyId,
        ...formValue
      }
    } else {
      formValue = {
        id: 0,
        date: this.currentDate,
        projectid: this.salesLeadsId,
        ...formValue
      }
    }
    formValue.description = this.quitChartesSpecials(formValue.description);
    console.log('Form blog', formValue);

    this.GeneralService.postInsertUpdategeneral('ProjectBlog/InsertUpdateProjectBlog', null, formValue).subscribe(
      data => {
        console.log('InsertUpdateTask', data);
        this.action.next({ success: true, data: data[0].Result });
        this.initForm();
        this.toast.success(this.translate.instant('msgBloCreSucc'));
      }
      , err => {
        console.log(err);
        this.toast.error('Error adding blog');
      }
    )

  }

  getcurrentDate() {
    let f = new Date();
    let month: string;
    let day: string;

    if ((f.getMonth() + 1) < 10) {
      month = '0' + (f.getMonth() + 1);
    } else {
      month = (f.getMonth() + 1) + '';
    }
    if ((f.getDate()) < 10) {
      day = '0' + (f.getDate());
    } else {
      day = (f.getDate()) + '';
    }
    this.currentDate = (f.getFullYear() + (month) + day) + ' ' + f.getHours() + ':' + f.getMinutes() + ':' + f.getSeconds();
  }

  quitChartesSpecials(string) {//solo letras y numeros
    var out = '';
    //Se añaden las letras validas
    var filtro = 'abcdefghijklmnñopqrstuvwxyzABCDEFGHIJKLMNÑOPQRSTUVWXYZ1234567890.;.*´()-_ ';//Caracteres validos

    for (var i = 0; i < string.length; i++)
      if (filtro.indexOf(string.charAt(i)) != -1)
        out += string.charAt(i);
    return out;
  }


}
